export default __webpack_public_path__ + "static/homesta-ad-banner-3c0404f14790c6047962b1ea23423c40.png";